import React from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getBankById, getDayOfWeekById } from '../../utils/Enums';

const ViewSupplierModal = ({ open, onClose, supplier }) => {
  const { t } = useTranslation();

  if (!supplier) {
    return null; // or a loading spinner, or a placeholder component
  }

  const bank = getBankById(supplier.bank.id);
  const deliveryDays = supplier.deliveryDays
    ? supplier.deliveryDays
        .split(',')
        .map(day => getDayOfWeekById(day))
        .filter(Boolean)
        .map(day => t(day.label))
        .join(', ')
    : '';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle><span className="roboto-regular">{t('view_supplier')}</span></DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('name')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.name}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('business_name')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.businessName}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('rut')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.rut}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('pickup_address')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.pickupAddress}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('business_phone')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.businessPhone}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('email')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.email}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('seller_name')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.sellerName}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('seller_phone')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.sellerPhone}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('bank')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{bank.label}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('bank_account')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.bankAccount}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('credit_days')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.creditDays}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('anticipation_days')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{supplier.anticipationDays}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-regular">{t('delivery_days')}</span></Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1"><span className="roboto-light">{deliveryDays}</span></Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewSupplierModal;
